import {
  Flex,
  FlexAnchor,
  FlexAnchorProps,
  Icon,
  lgBumps,
  mdBumps,
  Typo,
} from '@wrisk/ui-components'
import { TFunction } from 'i18next'
import React from 'react'
import { FunctionComponent } from 'react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'

import { tDefaults, TKeyBuilder } from '../../../../infrastructure/internationalisation'
import { InputLoopConfig } from '../../../../state/configuration'
import { FormFormatter } from '../../FormFormatter'

export interface ReadOnlyLoopProps extends Omit<FlexAnchorProps, 'ref' | 'onClick'> {
  t: TFunction
  tKey: TKeyBuilder
  item: InputLoopConfig
  onClick: () => void
}

export const ReadOnlyLoop: FunctionComponent<ReadOnlyLoopProps> = ({
  t,
  tKey,
  item,
  onClick,
  ...props
}) => {
  const { control } = useFormContext()
  const { fields } = useFieldArray({
    name: item.name,
    control,
  })

  if (fields.length === 0) {
    return (
      <FlexAnchor
        borderRadius={2}
        backgroundColor='surfaceDisabled'
        p={mdBumps}
        onClick={onClick}
        {...props}
      >
        <Typo fontFamily='input' color='textDisabled'>
          {t(tDefaults('inputs.none'))}
        </Typo>
        <Icon icon='info' size='tiny' ml={lgBumps} color='textDisabled' />
      </FlexAnchor>
    )
  }

  const elements = fields.map((field, index) => (
    <Flex key={field.id} width={1} backgroundColor='surfaceDisabled'>
      <Flex
        width={1}
        p={mdBumps}
        gap={[2, 0]}
        flexDirection='column'
        alignItems='flex-start'
        justifyContent='flex-start'
      >
        {item.meta?.form.map((it, inputIndex) => {
          return (
            <Controller
              key={`${field.id}-${inputIndex}`}
              control={control}
              name={`${item.name}.${index}.${it.name}`}
              defaultValue={field?.[it.name]}
              render={({ field: { value } }) => (
                <Typo fontFamily='input' color='textDisabled'>
                  <Typo
                    fontFamily='input'
                    fontWeight='bold'
                    display={['block', 'inline']}
                    pr={1}
                  >
                    {t(tKey(item.name, 'inputs', it.name, 'summary'))}:
                  </Typo>
                  <FormFormatter input={it} value={value} t={t} />
                </Typo>
              )}
            />
          )
        })}
      </Flex>
      <Icon icon='info' size='tiny' ml={lgBumps} mr={mdBumps} color='textDisabled' />
    </Flex>
  ))

  return (
    <FlexAnchor
      width={1}
      gap='1px'
      borderRadius={2}
      flexDirection='column'
      alignItems='flex-start'
      overflow='hidden'
      onClick={onClick}
      {...props}
    >
      {elements}
    </FlexAnchor>
  )
}
